import { truncateText } from "../utils/strings";

const defaultLimit = 6;

function createCardTicket({ href = '#', ticketId = null, ticketTitle = null, dateCreation = null, dateSolved = null, isSolved = false, isClosed = false }) {

    const div = document.createElement('div');
    div.className = 'col-12 col-md-4';
    div.setAttribute('data-solved', isSolved ? 1 : 0);
    div.setAttribute('data-closed', isClosed ? 1 : 0);

    const card = document.createElement('a');
    card.className = `card-ticket ${isSolved ? ( isClosed ? 'card-ticket-closed' : "card-ticket-solved" ): 'card-ticket-open'}`;
    card.href = href;

    const title = document.createElement('h3');
    title.innerText = `Chamado nº ${ticketId || 'S/N'}`;
    card.appendChild(title);


    const content = document.createElement('p');
    content.className = 'small';
    content.innerHTML = `
        ${ticketTitle ? truncateText(ticketTitle, 23) : 'S/N'}
        <br>
        <b>Aberto</b>: ${dateCreation || "S/N"}
        <br>
        <b>Solucionado</b>: ${dateSolved || "S/N"}
    `;
    card.appendChild(content);


    const corner = document.createElement('div');
    corner.className = 'go-corner'
    corner.href = '#';
    corner.setAttribute('data-solved', isSolved ? 1 : 0);


    const arrow = document.createElement('div');
    arrow.className = 'go-arrow'

    const iconArrow = document.createElement('i');
    iconArrow.className = 'fas fa-arrow-right';

    const smallIconArrow = document.createElement('small');
    smallIconArrow.appendChild(iconArrow);

    arrow.appendChild(smallIconArrow);

    corner.appendChild(arrow);
    card.appendChild(corner);


    div.appendChild(card);

    return div;
}


async function getTicketRequest() {
    try {
        const offset = document.querySelector('input#offset');
        const response = await axios.post('/admin/ticket/get-tickets', {
            limit: defaultLimit,
            offset: parseInt(offset.value),
            status: document.getElementById('status').value
        }
        );
        return response;
    } catch (error) {
        return false;
    }
}

async function getLoadingNewTicketsRequest() {
    const panelTickets = document.getElementById('ticket_panel');
    const panelLoading = document.getElementById('panel-loading');
    const errorSearchTicket = `<h5 class="text-danger">Erro ao buscar os chamados!</h5>`;

    if (panelTickets) {
        const response = await getTicketRequest();
        const statusCode = response.status;

        if (response && statusCode == 200) {
            const { total, tickets } = response.data;

            if (tickets.length > 0) {
                let again = true;

                const offset = document.querySelector('input#offset');
                offset.value = parseInt(offset.value) + defaultLimit;

                if (tickets.length <= defaultLimit && (parseInt(offset.value) >=  total) ) again = false;


                for (let ticket of tickets) {

                    console.log(ticket);

                    const card = createCardTicket({ href: `/admin/ticket/${ticket.id}`, ticketId: ticket.id, ticketTitle: ticket.title, dateCreation: ticket.date_creation, dateSolved: ticket.date_solved, isSolved: ticket.is_solved , isClosed: ticket.is_closed });
                    panelTickets.appendChild(card);
                }

                return again;
            }


            return false;
        }
        else {
            panelLoading.innerHTML = errorSearchTicket;
            return false;
        }
    }
}

async function startTickets() {
    const panelTickets = document.getElementById('ticket_panel');
    const noTicket = `<h5 class="text-danger">Sem Chamados Abertos</h5>`;
    const errorSearchTicket = `<h5 class="text-danger">Erro ao buscar os chamados!</h5>`;
    const offset = document.querySelector('input#offset');

    if(offset) offset.value = 0;

    if (panelTickets) {
        const panelLoading = document.getElementById('panel-loading');
        const divLoading = document.querySelector('div#loading-button');
        const divSpinner = document.querySelector('div#loading-spinner');

        const btnLoading = divLoading ? divLoading.querySelector('a#btn-loading') : null;

        if (divLoading && divSpinner) {
            divLoading.classList.add('d-none');
            divSpinner.classList.add('d-none');
        }

        divSpinner.classList.remove('d-none');

        setTimeout(async () => {
            const response = await getTicketRequest();
            const statusCode = response.status;

            if (response && statusCode == 200) {
                divSpinner.classList.add('d-none');

                const { total, tickets } = response.data;

                if (total === 0 || tickets.length == 0) {
                    return panelLoading.innerHTML = noTicket;
                }

                if (tickets.length > 0) {
                    offset.value = parseInt(offset.value) + defaultLimit;


                    for (let ticket of tickets) {
                        const card = createCardTicket({ href: `/admin/ticket/${ticket.id}`, ticketId: ticket.id, ticketTitle: ticket.title, dateCreation: ticket.date_creation, dateSolved: ticket.date_solved, isSolved: ticket.is_solved, isClosed: ticket.is_closed });
                        panelTickets.appendChild(card);
                    }



                    if (tickets.length >= defaultLimit) {
                        divLoading.classList.remove('d-none');

                        if (btnLoading && !divLoading.classList.contains('event-set')) {
                            const btnLoadingListener = async (e) => {
                                divLoading.classList.add('d-none');
                                divSpinner.classList.remove('d-none');

                                const showLoading = await getLoadingNewTicketsRequest();

                                if (showLoading) {
                                    divSpinner.classList.add('d-none');
                                    divLoading.classList.remove('d-none');
                                }
                                else {
                                    divSpinner.classList.add('d-none');
                                    divLoading.classList.add('d-none');
                                }

                            };
                            btnLoading.addEventListener('click', btnLoadingListener);
                            divLoading.classList.add('event-set');
                        }
                    }
                }

            }
            else {
                return panelLoading.innerHTML = errorSearchTicket;
            }

        }, 1500);
    }
}


startTickets();
